import { render, staticRenderFns } from "./SingleProvider.vue?vue&type=template&id=b32d9c0e&"
import script from "./SingleProvider.vue?vue&type=script&lang=js&"
export * from "./SingleProvider.vue?vue&type=script&lang=js&"
import style0 from "./SingleProvider.vue?vue&type=style&index=0&id=b32d9c0e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports